
              import "_sentry-module-metadata-injection-stub";
              import * as OriginalModule from "/var/www/vhosts/roh_production/reviveourhearts_com/public/static/ts/dist/ts/src/components/QuestionAnswerAccordion/App.bc9b8ae4eb73.js";
              export default OriginalModule.default;
              export * from "/var/www/vhosts/roh_production/reviveourhearts_com/public/static/ts/dist/ts/src/components/QuestionAnswerAccordion/App.bc9b8ae4eb73.js";